import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const StyledMenuWrapper = styled.div`
    position: relative;
`;

export const StyledIcon = styled(FlexRow)`
    align-items: center;
    justify-content: center;
`;

export const StyledInnerItem = styled(FlexRow)`
    gap: 8px;
`;
